import { configureStore } from "@reduxjs/toolkit";
import dateSlice from "../slices/dateSlice";
import modalSlice from "../slices/modalSlice";
import filterSlice from "../slices/filterSlice";
import volSearchBarSlice from "../slices/volSearchBarSlice";
import commentSlice from "../slices/commentSlice";
import sbHebergSlice from "../slices/sbHebergSlice";
import userSlice from "../slices/userSlice";
import messageSlice from "../slices/messageSlice";
import sbCarsLocationSlice from "../slices/sbLocation";
import pdfReservationHebergSlice from "../slices/pdfReservationHebergSlice";
import reservationHebergSlice from "../slices/reservationHebergSlice";
import  myAnnouncesSlice  from "../slices/myAnnoucesSlice";

export  const storeKit = configureStore({
  reducer: {
    modal : modalSlice,
    date : dateSlice,
    filter : filterSlice,
    volBarFilter : volSearchBarSlice,
    comment : commentSlice,
    sideBareHebergement : sbHebergSlice,
    sideBarCarsLocation : sbCarsLocationSlice,
    user : userSlice,
    messages : messageSlice ,
    showReservationHeberg : pdfReservationHebergSlice,
    reservationHeberg : reservationHebergSlice,
    myAnnounces:myAnnouncesSlice
  },
});
